import * as z from 'zod';

/**
 * The mode for how campaign-provided content interacts with default content.
 * - `replace`: The campaign content entirely replaces the default.
 * - `append`: The campaign content is appended after the default.
 */
export const CampaignCheckoutContentMode = z.enum(['replace', 'append']);
export type CampaignCheckoutContentMode = z.infer<
  typeof CampaignCheckoutContentMode
>;

/**
 * Resolved campaign checkout content from Contentful.
 *
 * This represents the rendered payload attached to the cart when a campaign
 * has a `cmsContentId` pointing to a "Campaign Checkout Content"
 * entry in Contentful.
 */
export const CampaignCheckoutCmsContent = z.object({
  /** The Entry ID of the Checkout Content Entry */
  entryId: z.string().optional().nullable(),
  /** Controls whether the custom disclaimer replaces or appends to the default. */
  disclaimerMode: CampaignCheckoutContentMode.optional().nullable(),
  /** Contentful Rich Text document JSON for the cart disclaimer. */
  disclaimerBody: z.unknown().optional().nullable(),
  /** Controls whether the custom thank-you message replaces or appends to the default. */
  thankYouMode: CampaignCheckoutContentMode.optional().nullable(),
  /** Contentful Rich Text document JSON for the checkout complete message. */
  thankYouBody: z.unknown().optional().nullable(),
  /** Override label for the primary CTA on checkout complete. */
  ctaLabel: z.string().optional().nullable(),
  /** Override URL for the primary CTA on checkout complete. */
  ctaUrl: z.string().optional().nullable(),
});
export type CampaignCheckoutCmsContent = z.infer<
  typeof CampaignCheckoutCmsContent
>;
